/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReferredProjectStatus = {
    Evaluated: 'EVALUATED',
    Approved: 'APPROVED',
    OngoingProject: 'ONGOING_PROJECT',
    Cancelled: 'CANCELLED',
    Ended: 'ENDED'
} as const;
export type ReferredProjectStatus = typeof ReferredProjectStatus[keyof typeof ReferredProjectStatus];


export function instanceOfReferredProjectStatus(value: any): boolean {
    for (const key in ReferredProjectStatus) {
        if (Object.prototype.hasOwnProperty.call(ReferredProjectStatus, key)) {
            // @ts-ignore
            if (ReferredProjectStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferredProjectStatusFromJSON(json: any): ReferredProjectStatus {
    return ReferredProjectStatusFromJSONTyped(json, false);
}

export function ReferredProjectStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredProjectStatus {
    return json as ReferredProjectStatus;
}

export function ReferredProjectStatusToJSON(value?: ReferredProjectStatus | null): any {
    return value as any;
}

